// extracted by mini-css-extract-plugin
module.exports = {"shadow":"_9e1425b4d3--shadow--tjggX"};